module.exports = __webpack_public_path__ + "img/modal-ball-2.5925e127.png";